import ReconnectingWebSocket from 'reconnecting-websocket'

const state = {
    socket: null,
    isConnected: false,
    onOpenHandlers: [],
    onMessageHandlers: []
}

const getters = {}

const mutations = {
    SOCKET_ONOPEN(state) {
        state.isConnected = true
        state.onOpenHandlers.forEach(fn => {
            fn()
        })
    },
    SOCKET_ONCLOSE(state) {
        state.isConnected = false
    },
    SOCKET_ONERROR(state, payload) {
        console.error(state, payload)
    },
    SOCKET_ONMESSAGE(state, message) {
        state.onMessageHandlers.forEach(fn => {
            fn(message)
        })
    }
}

const actions = {
    connect({state, commit, rootState, rootGetters}) {
        if (process.env.VUE_APP_PICA_DISABLE_WEBSOCKETS) return;
        if (state.isConnected || !rootGetters['auth/isAuthenticated']) return
        if (process.env.VUE_APP_DISABLE_WEBSOCKET) return

        const options = {
            connectionTimeout: 1000, // retry connect if not connected after this time
            maxRetries: 200, // maximum number of retries
            automaticOpen: true
        }
        const subprotocols = null
        state.socket = new ReconnectingWebSocket(
            `${process.env.VUE_APP_PICA_CORE_WEBSOCKETS_URL}?token=${rootState.auth.token}`,
            subprotocols,
            options)
        state.socket.onopen = (e) => {
            commit('SOCKET_ONOPEN')
        }
        state.socket.onmessage = (e) => {
            const message = JSON.parse(e.data)
            commit('SOCKET_ONMESSAGE', message)
        }
        state.socket.onerror = (e) => {
            commit('SOCKET_ONERROR', e)
        }
        state.socket.onclose = (e) => {
            commit('SOCKET_ONCLOSE')
        }
    },
    close(state) {
        if (state.socket) state.socket.close()
    },
    sendMessage({state, dispatch}, message) {
        if (state.isConnected) {
            state.socket.send(JSON.stringify(message))
        } else {
            const onOpenHandler = () => {
                state.socket.send(JSON.stringify(message))
                dispatch('unsubscribeOnOpenHandler', onOpenHandler)
            }
            dispatch('subscribeOnOpenHandler', onOpenHandler)
            dispatch('connect')
        }
    },
    subscribeOnOpenHandler({state}, fn) {
        state.onOpenHandlers.push(fn)
    },
    unsubscribeOnOpenHandler({state}, fn) {
        state.onOpenHandlers = state.onOpenHandlers.filter(i => i !== fn)
    },
    subscribeOnMessageHandler({state}, fn) {
        state.onMessageHandlers.push(fn)
    },
    unsubscribeOnMessageHandler({state}, fn) {
        state.onMessageHandlers = state.onMessageHandlers.filter(i => i !== fn)
    }
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
